import React, { Component } from 'react';
import { Card, CardHeader, CardBody, Input, InputGroup, InputGroupAddon, Button } from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import async from 'async';

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter, dateFilter, selectFilter, multiSelectFilter } from 'react-bootstrap-table2-filter';

import UsersEditor from './Editor';

import Lang from '../../languages';
import Config from '../../config';

import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './List.css';

class UsersList extends Component {
 constructor(props) {
  super(props);

  this.state = {
   page: 1,
   data: [],
   totalSize: 0,
   sizePerPage: 10,
   sortField: 'username',
   editorWindow: false,
   confirmValue: '',
   selected: [],
   selectedUser: null
  };

  this.userType = this.props.location.pathname.split('/').length > 2 ? this.props.location.pathname.split('/')[2] : false;


  this.filters = { 'text': {}, 'select': {}, 'number': {}, 'date': {} }

  this.columns = [];

  if (window.innerWidth <= 768) {
   this.columns.push({ dataField: 'username', text: Lang[this.props.session.language].Users.columns.username, sort: true });
  } else {
   this.columns.push({ dataField: 'username', text: Lang[this.props.session.language].Users.columns.username, filter: textFilter({ getFilter: (filter) => { this.filters['text'].username = filter } }), sort: true });
   this.columns.push({ dataField: 'email', text: Lang[this.props.session.language].Users.columns.email, filter: textFilter({ getFilter: (filter) => { this.filters['text'].email = filter } }), sort: true });
   if(!this.userType) this.columns.push({
    dataField: 'role', text: Lang[this.props.session.language].Users.columns.role, filter: multiSelectFilter({
     options: { operators: Lang[this.props.session.language].Users.titles['operators'], providers: Lang[this.props.session.language].Users.titles['providers'], administrators: Lang[this.props.session.language].Users.titles['administrators'] },
     getFilter: (filter) => { this.filters['select'].role = filter }
    }), formatter: (cellContent, row) => { return Lang[this.props.session.language].Users.titles[cellContent] }, sort: true
   });
   this.columns.push({ dataField: 'parent', text: Lang[this.props.session.language].Users.columns.parent, filter: textFilter({ getFilter: (filter) => { this.filters['text'].parent = filter } }), sort: true },
    {
     dataField: 'status', text: Lang[this.props.session.language].Users.columns.status, filter: selectFilter({
      options: { enabled: Lang[this.props.session.language].Status['enabled'], disabled: Lang[this.props.session.language].Status['disabled'] },
      getFilter: (filter) => { this.filters['select'].status = filter }
     }), formatter: cell => selectOptions[cell], headerStyle: () => { return { width: '8%' } }, formatter: (cellContent, row) => { return Lang[this.props.session.language].Status[cellContent] }, sort: true
    });
   this.columns.push({ dataField: 'reg_date', text: Lang[this.props.session.language].Users.columns.reg_date, filter: dateFilter({ getFilter: (filter) => { this.filters['date'].reg_date = filter } }), headerStyle: () => { return { width: '10%' } }, sort: true });
   this.columns.push({
    dataField: 'ID', text: 'ID', headerStyle: () => { return { width: '108px' } }, headerFormatter: () => (
     <Button className="float-right" title="Restablecer filtros" onClick={this.resetFilters}><i className="fa fa-filter"></i>&nbsp;{Lang[this.props.session.language].tableReset}</Button>
    ), formatter: (cellContent, row) => {
     return (
      <div className="checkbox disabled">
       {
        this.props.session.permissions.users[row.role].find(el => el == 'update') ?
         <Button color="primary" onClick={() => this.openEditor(cellContent)}><i className="fa fa-edit"></i></Button>
         : null
       }
       {' '}
       {
        this.props.session.permissions.users[row.role].find(el => el == 'delete') ?
         <Button color="danger" onClick={() => this.doDelete(cellContent)}><i className="fa fa-trash"></i></Button>
         : null
       }
      </div>
     )
    }
   });
  }

  this.doDelete = this.doDelete.bind(this);

  this.openEditor = this.openEditor.bind(this);
  this.closeEditor = this.closeEditor.bind(this);

  this.resetFilters = this.resetFilters.bind(this);
  this.handleOnSelect = this.handleOnSelect.bind(this);
  this.handleOnSelectAll = this.handleOnSelectAll.bind(this);
  this.handleTableChange = this.handleTableChange.bind(this);
  this.handleClickDelete = this.handleClickDelete.bind(this);
 }

 getUserType() {
  return this.props.location.pathname.split('/').length > 2 ? this.props.location.pathname.split('/')[2] : false;
 }

 resetFilters() {
  Object.keys(this.filters).forEach(type => {
   Object.keys(this.filters[type]).forEach(key => {
    var filterFunction = this.filters[type][key];
    switch (type) {
     case 'text': filterFunction(''); break;
     case 'select': filterFunction(''); break;
     case 'date': filterFunction({ date: new Date(), comparator: '' }); break;
     case 'number': filterFunction({ number: '', comparator: '' }); break;
    }
   });
  })
 }

 handleOnSelect(row, isSelect, rowIndex, e) {
  if (isSelect) {
   this.setState({ selected: [...this.state.selected, row.ID] });
  } else {
   this.setState({ selected: this.state.selected.filter(x => x !== row.ID) });
  }
 }

 handleOnSelectAll(isSelect, rows, e) {
  const IDs = rows.map(r => r.ID);
  if (isSelect) {
   this.setState({ selected: [...this.state.selected, ...IDs] });
  } else {
   this.setState({ selected: this.state.selected.filter((e) => { return IDs.indexOf(e) < 0 }) });
  }
 }

 handleTableChange(type, { page, sizePerPage, filters, sortField, sortOrder }) {
  this.props.reqAPI(Config.apiURI + '/api/users', 'POST', { userType: this.getUserType(), page, sizePerPage, filters, sortField, sortOrder }).then(data => {
   this.setState(() => ({ page, data: data.items, totalSize: data.total, sizePerPage, filters, sortField, sortOrder }));
  });
 }


 handleClickDelete(IDs, onClose) {
  if (this.state.confirmValue == Lang[this.props.session.language].DeleteConfirmValue) {
   var jobs = [];
   var self = this;
   IDs.map((ID) => {
    jobs.push(function (callback) {
     self.props.reqAPI(Config.apiURI + '/api/users/' + ID, 'DELETE').then(result => {
      callback(false, result);
     });
    })
   })

   async.parallel(jobs, function (err, results) {
    onClose();
    self.setState({ confirmValue: '' }, () => {
     self.handleTableChange('reload', {
      page: self.state.page,
      sizePerPage: self.state.sizePerPage,
      filters: self.state.filters,
      sortField: self.state.sortField,
      sortOrder: self.state.sortOrder
     });
    })

    for (var key = 0; key < results.length; key++) {
     if (results[key].success) toast.success(Lang[self.props.session.language].Users.hasBeenDeleted(results[key].name));
     else toast.error(Lang[self.props.session.language].Users.hasNotBeenDeleted(results[key].name), { autoClose: 10000 });
    }
   });
  }
 }


 doDelete(ID, error = false) {
  var IDs = ID === null ? this.state.selected : typeof (ID) === 'object' ? ID : [ID];
  confirmAlert({
   customUI: ({ onClose }) => {
    return (
     <Card className='confirm-delete alert-danger'>
      <CardBody>
       <h2>{Lang[this.props.session.language].DeleteConfirmTitle}</h2>
       <p>{Lang[this.props.session.language].Users.isGoingToDelete(IDs)}</p>
       <p><strong>{Lang[this.props.session.language].DeleteConfirmMessage}</strong></p>
       <InputGroup>
        <Input type="text" placeholder={Lang[this.props.session.language].DeleteConfirmPlaceholder}
         onKeyPress={(event) => { if (event.key === 'Enter') this.handleClickDelete(IDs, onClose); }}
         onChange={(e) => { this.setState({ confirmValue: e.target.value }); }}
         className={error ? 'border border-danger' : ''}
        />
        <InputGroupAddon addonType="append">
         <Button color="danger" onClick={() => { this.handleClickDelete(IDs, onClose); }}>{Lang[this.props.session.language].DeleteConfirmYES}</Button>
         <Button color="primary" onClick={onClose}>{Lang[this.props.session.language].DeleteConfirmNO}</Button>
        </InputGroupAddon>
       </InputGroup>
      </CardBody>
     </Card>
    );
   }
  });
 }


 openEditor(ID) {
  if (ID === null) {
   this.setState({ selectedUser: { userType: this.getUserType() } }, function () {
    this.setState({ editorWindow: true });
   });
  } else {
   this.props.reqAPI(Config.apiURI + '/api/users/' + ID + '?full').then(user => {
    this.setState({ selectedUser: user }, function () {
     this.setState({ editorWindow: true });
    });
   })
  }
 }

 closeEditor(state) {
  if (state) toast.success('Los cambios han sido guardados');
  this.setState({ selectedUser: null, editorWindow: false });
  this.handleTableChange('reload', {
   page: this.state.page,
   sizePerPage: this.state.sizePerPage,
   filters: this.state.filters,
   sortField: this.state.sortField,
   sortOrder: this.state.sortOrder
  });
 }

 componentDidUpdate(previousProps, previousState) {
  if (previousProps.location.pathname !== this.props.location.pathname) {
   this.resetFilters();
  }
 }

 componentDidMount() {
  this.handleTableChange('reload', {
   page: this.state.page,
   sizePerPage: this.state.sizePerPage,
   filters: this.state.filters,
   sortField: this.state.sortField,
   sortOrder: this.state.sortOrder
  });
 }


 render() {
  return (
   <Card>
    <CardBody>
     {
      this.getUserType() ? this.props.session.permissions.users[this.getUserType()].find(el => el == 'create') ?
       <Button color="success" onClick={() => this.openEditor(null)}><i className="fa fa-plus"></i> {Lang[this.props.session.language].Users.buttons.addUser[this.getUserType()]}</Button> : null
       : null
     }
     {' '}
     {
      this.state.selected.length > 0 ?
       <Button color="danger" onClick={() => this.doDelete(null)}><i className="fa fa-minus"></i> {Lang[this.props.session.language].Users.buttons.delSelected}</Button> : ''
     }

     <BootstrapTable
      remote
      striped
      condensed
      bootstrap4
      keyField="ID"
      bordered={false}
      data={this.state.data ? this.state.data : []}
      columns={this.columns}
      selectRow={{
       mode: 'checkbox',
       onSelect: this.handleOnSelect,
       onSelectAll: this.handleOnSelectAll
      }}
      defaultSorted={[{
       dataField: 'name',
       order: 'asc'
      }]}
      filter={filterFactory()}
      pagination={
       paginationFactory({
        page: this.state.page,
        sizePerPage: this.state.sizePerPage,
        sizePerPageList: [
         { text: '5', value: 5 },
         { text: '10', value: 10 },
         { text: '25', value: 25 },
         { text: '50', value: 50 },
         { text: '100', value: 100 }
        ],
        showTotal: true,
        totalSize: this.state.totalSize,
        firstPageText: Lang[this.props.session.language].pagination.firstPageText,
        prePageText: Lang[this.props.session.language].pagination.prePageText,
        nextPageText: Lang[this.props.session.language].pagination.nextPageText,
        lastPageText: Lang[this.props.session.language].pagination.lastPageText,
        firstPageTitle: Lang[this.props.session.language].pagination.firstPageTitle,
        nextPageTitle: Lang[this.props.session.language].pagination.nextPageTitle,
        prePageTitle: Lang[this.props.session.language].pagination.prePageTitle,
        lastPageTitle: Lang[this.props.session.language].pagination.lastPageTitle,
        paginationTotalRenderer: (from, to, size) => (
         <span className="react-bootstrap-table-pagination-total" dangerouslySetInnerHTML={{ __html: '&nbsp;' + Lang[this.props.session.language].paginationFooter(from, to, size) + ' ' + Lang[this.props.session.language].Users.names[this.getUserType() ? this.getUserType() : 'users'] }} />
        )
       })
      }
      onTableChange={this.handleTableChange}
      noDataIndication={Lang[this.props.session.language].tableEmpty}
     />
    </CardBody>

    <UsersEditor {...this.props} open={this.state.editorWindow} user={this.state.selectedUser} handleClose={this.closeEditor} onComplete={this.closeEditor} />
   </Card>
  )
 }
}

export default UsersList;



// WEBPACK FOOTER //
// ./websources/views/Users/List.js